/**
 * React Query keys for the data-room feature, scoped by startup id so the
 * cache is correct per acting entity (ADR FE-1). Kept in one place so every
 * reader and invalidator uses the same key.
 */
export const dataRoomKeys = {
  entitlement: (startupId: string) => ['data-room', startupId, 'entitlement'] as const,
};
